document.addEventListener('DOMContentLoaded', function () {
  const emptyBtn = document.getElementById('mochi-empty-cart-btn');
  if (!emptyBtn) return;

  function setState(text, disabled) {
    emptyBtn.textContent = text;
    emptyBtn.disabled = !!disabled;
  }

  emptyBtn.addEventListener('click', async function () {
    try {
      setState('Vaciando... 🧺', true);

      const res = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin'
      });

      if (!res.ok) throw new Error('Error al vaciar');

      setState('Carrito vacío ✨', false);

      // Refrescar minicart si tu tema lo soporta
      document.dispatchEvent(new Event('cart:refresh'));
      window.dispatchEvent(new CustomEvent('mochi:cart:updated'));

    } catch (err) {
      console.error(err);
      setState('Error ❌', false);
    }
  });
});
